var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.meta.navShow)?_c('div',{staticClass:"top_back"},[_c('div',{staticClass:"top_back_arrow",on:{"click":_vm.topback}},[_c('img',{staticClass:"top_back_img",attrs:{"src":"/static/imgs/back.svg"}})]),_vm._v(" "),_c('div',{staticClass:"top_back_title"},[_vm._v("\n    "+_vm._s(_vm.$route.meta.title)+"\n  ")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a895a92a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/topback.vue
// module id = null
// module chunks = 